function CertificateSkeleton() {
  return (
    <div className="mb-2 rounded-lg bg-white shadow-md">
      <div className="mb-2 h-48 w-full animate-pulse rounded-lg bg-gray-400" />
      <div className="px-1 pb-1">
        <div className="flex items-center justify-between">
          <div className="mb-2 h-4 w-40 animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
        </div>
        <div className="mb-2 h-4 w-2/3 animate-pulse rounded-md bg-gray-400" />
        <div className="mb-2 h-4 w-full animate-pulse rounded-md bg-gray-400" />
        <div className="mb-2 h-4 w-4/5 animate-pulse rounded-md bg-gray-400" />
      </div>
    </div>
  );
}

export default CertificateSkeleton;
